import { defineStyle, defineStyleConfig } from '@chakra-ui/react';
import { variantFilled, variantFlushed, variantOutlined } from '../../focusShim';
const baseStyle = defineStyle(() => {
  return {
    // I don't know why I can't just use borderColor
    borderTopColor: 'GREYSCALE.MILKY_WAY !important',
    borderRightColor: 'GREYSCALE.MILKY_WAY !important',
    borderBottomColor: 'GREYSCALE.MILKY_WAY !important',
    borderLeftColor: 'GREYSCALE.MILKY_WAY !important',
    borderRadius: '30px',
    _focus: variantOutlined()
  };
});
const pill = defineStyle({
  border: '1px',
  borderRadius: '20px',
  _focus: variantOutlined()
});
const filled = defineStyle({
  border: 'none',
  _focus: Object.assign({
    backgroundColor: 'GREYSCALE.SUPERNOVA'
  }, variantFilled()),
  _invalid: {
    border: '1px solid',
    borderColor: 'KYOTO.regular !important'
  }
});
const flushed = defineStyle({
  _focus: Object.assign({}, variantFlushed())
});
export const textareaTheme = defineStyleConfig({
  baseStyle,
  variants: {
    pill,
    filled,
    flushed
  }
});